"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get getAlias () {
        return getAlias;
    },
    get ncIsStringHasValue () {
        return ncIsStringHasValue;
    },
    get negatedMapping () {
        return negatedMapping;
    },
    get nestedConditionJoin () {
        return nestedConditionJoin;
    },
    get unsupportedFilter () {
        return unsupportedFilter;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
const _lookupHelpers = require("~/helpers/lookupHelpers");
const _ncError = require("~/helpers/ncError");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ncIsStringHasValue(val) {
    return val !== '' && !(0, _nocodbsdk.ncIsUndefined)(val) && !(0, _nocodbsdk.ncIsNull)(val);
}
const negatedMapping = {
    nlike: {
        comparison_op: 'like'
    },
    neq: {
        comparison_op: 'eq'
    },
    blank: {
        comparison_op: 'notblank'
    },
    notchecked: {
        comparison_op: 'checked'
    },
    nanyof: {
        comparison_op: 'anyof'
    },
    nallof: {
        comparison_op: 'allof'
    }
};
function getAlias(aliasCount) {
    return `__nc${aliasCount.count++}`;
}
async function nestedConditionJoin({ baseModelSqlv2, filter, lookupColumn, knex, alias, aliasCount, throwErrorIfInvalid, parseConditionV2 }) {
    const context = baseModelSqlv2.context;
    const clauses = [];
    const rootAppliances = [];
    if (lookupColumn.uidt === _nocodbsdk.UITypes.Lookup || lookupColumn.uidt === _nocodbsdk.UITypes.LinkToAnotherRecord) {
        const relationColumn = lookupColumn.uidt === _nocodbsdk.UITypes.Lookup ? await (await lookupColumn.getColOptions(context)).getRelationColumn(context) : lookupColumn;
        const relationColOptions = await relationColumn.getColOptions(context);
        const relAlias = `__nc${aliasCount.count++}`;
        const { parentContext, childContext, mmContext, refContext } = await relationColOptions.getParentChildContext(context);
        const childColumn = await relationColOptions.getChildColumn(childContext);
        const parentColumn = await relationColOptions.getParentColumn(parentContext);
        const childModel = await childColumn.getModel(childContext);
        await childModel.getColumns(childContext);
        const parentModel = await parentColumn.getModel(parentContext);
        await parentModel.getColumns(parentContext);
        const parentBaseModel = await _models.Model.getBaseModelSQL(parentContext, {
            model: parentModel,
            dbDriver: baseModelSqlv2.dbDriver
        });
        const childBaseModel = await _models.Model.getBaseModelSQL(childContext, {
            model: childModel,
            dbDriver: baseModelSqlv2.dbDriver
        });
        {
            const relationType = (0, _nocodbsdk.isMMOrMMLike)(relationColumn) ? 'mm' : relationColOptions.type;
            switch(relationType){
                case _nocodbsdk.RelationTypes.HAS_MANY:
                    {
                        var _parseProp;
                        const useRecursiveEvaluation = (_parseProp = (0, _nocodbsdk.parseProp)(lookupColumn.meta)) == null ? void 0 : _parseProp.useRecursiveEvaluation;
                        // TODO: [recursive lookup]
                        // eslint-disable-next-line no-constant-condition
                        if (false && useRecursiveEvaluation) {
                            rootAppliances.push(await (0, _lookupHelpers.recursiveCTEFromLookupColumn)({
                                baseModelSqlV2: childBaseModel,
                                lookupColumn,
                                tableAlias: relAlias
                            }));
                            clauses.push((qb)=>{
                                qb.join(knex(`${relAlias} as ${relAlias}`).where(`${relAlias}.root_id`, '<>', baseModelSqlv2.dbDriver.raw('??.??', [
                                    relAlias,
                                    'id'
                                ])).as(relAlias), `${relAlias}.root_id`, `${alias}.${parentColumn.column_name}`);
                            });
                        } else {
                            clauses.push((qb)=>{
                                qb.join(knex.raw(`?? as ??`, [
                                    childBaseModel.getTnPath(childModel.table_name),
                                    relAlias
                                ]), `${alias}.${parentColumn.column_name}`, `${relAlias}.${childColumn.column_name}`);
                            });
                        }
                    }
                    break;
                case _nocodbsdk.RelationTypes.BELONGS_TO:
                    {
                        var _parseProp1;
                        const useRecursiveEvaluation = (_parseProp1 = (0, _nocodbsdk.parseProp)(lookupColumn.meta)) == null ? void 0 : _parseProp1.useRecursiveEvaluation;
                        // TODO: [recursive lookup]
                        // eslint-disable-next-line no-constant-condition
                        if (false && useRecursiveEvaluation) {
                            rootAppliances.push(await (0, _lookupHelpers.recursiveCTEFromLookupColumn)({
                                baseModelSqlV2: childBaseModel,
                                lookupColumn,
                                tableAlias: relAlias
                            }));
                            clauses.push((qb)=>{
                                qb.join(knex.raw(`?? as ??`, [
                                    relAlias,
                                    relAlias
                                ]), `${alias}.${parentColumn.column_name}`, `${relAlias}.root_id`);
                            });
                        } else {
                            clauses.push((qb)=>{
                                qb.join(knex.raw(`?? as ??`, [
                                    parentBaseModel.getTnPath(parentModel.table_name),
                                    relAlias
                                ]), `${alias}.${childColumn.column_name}`, `${relAlias}.${parentColumn.column_name}`);
                            });
                        }
                    }
                    break;
                case 'mm':
                    {
                        const mmModel = await relationColOptions.getMMModel(mmContext);
                        const mmParentColumn = await relationColOptions.getMMParentColumn(mmContext);
                        const mmChildColumn = await relationColOptions.getMMChildColumn(mmContext);
                        const mmBaseModel = await _models.Model.getBaseModelSQL(mmContext, {
                            model: mmModel,
                            dbDriver: baseModelSqlv2.dbDriver
                        });
                        const assocAlias = `__nc${aliasCount.count++}`;
                        clauses.push((qb)=>{
                            qb.join(knex.raw(`?? as ??`, [
                                mmBaseModel.getTnPath(mmModel.table_name),
                                assocAlias
                            ]), `${assocAlias}.${mmChildColumn.column_name}`, `${alias}.${childColumn.column_name}`).join(knex.raw(`?? as ??`, [
                                parentBaseModel.getTnPath(parentModel.table_name),
                                relAlias
                            ]), `${relAlias}.${parentColumn.column_name}`, `${assocAlias}.${mmParentColumn.column_name}`);
                        });
                    }
                    break;
            }
        }
        if (lookupColumn.uidt === _nocodbsdk.UITypes.Lookup) {
            const filterOperationResult = await nestedConditionJoin({
                baseModelSqlv2,
                filter,
                lookupColumn: await (await lookupColumn.getColOptions(context)).getLookupColumn(refContext),
                knex,
                alias: relAlias,
                aliasCount,
                throwErrorIfInvalid,
                parseConditionV2
            });
            clauses.push(filterOperationResult.clause);
            rootAppliances.push(filterOperationResult.rootApply);
        } else {
            const relationType = (0, _nocodbsdk.isMMOrMMLike)(relationColumn) ? 'mm' : relationColOptions.type;
            switch(relationType){
                case _nocodbsdk.RelationTypes.HAS_MANY:
                    {
                        var _childModel_displayValue;
                        const filterOperationResult = await parseConditionV2(childBaseModel, new _models.Filter(_extends({}, filter, {
                            fk_model_id: childModel.id,
                            fk_column_id: (_childModel_displayValue = childModel.displayValue) == null ? void 0 : _childModel_displayValue.id
                        })), aliasCount, relAlias, undefined, throwErrorIfInvalid);
                        clauses.push(filterOperationResult.clause);
                        rootAppliances.push(filterOperationResult.rootApply);
                        break;
                    }
                case _nocodbsdk.RelationTypes.BELONGS_TO:
                    {
                        var _parentModel_displayValue;
                        const filterOperationResult = await parseConditionV2(parentBaseModel, new _models.Filter(_extends({}, filter, {
                            fk_model_id: parentModel.id,
                            fk_column_id: parentModel == null ? void 0 : (_parentModel_displayValue = parentModel.displayValue) == null ? void 0 : _parentModel_displayValue.id
                        })), aliasCount, relAlias, undefined, throwErrorIfInvalid);
                        clauses.push(filterOperationResult.clause);
                        rootAppliances.push(filterOperationResult.rootApply);
                        break;
                    }
                case 'mm':
                    {
                        var _parentModel_displayValue1;
                        const filterOperationResult = await parseConditionV2(parentBaseModel, new _models.Filter(_extends({}, filter, {
                            fk_model_id: parentModel.id,
                            fk_column_id: (_parentModel_displayValue1 = parentModel.displayValue) == null ? void 0 : _parentModel_displayValue1.id
                        })), aliasCount, relAlias, undefined, throwErrorIfInvalid);
                        clauses.push(filterOperationResult.clause);
                        rootAppliances.push(filterOperationResult.rootApply);
                        break;
                    }
            }
        }
    } else {
        const filterOperationResult = await parseConditionV2(baseModelSqlv2, new _models.Filter(_extends({}, filter, {
            fk_model_id: (await lookupColumn.getModel(context)).id,
            fk_column_id: lookupColumn == null ? void 0 : lookupColumn.id
        })), aliasCount, alias, undefined, throwErrorIfInvalid);
        clauses.push(filterOperationResult.clause);
        rootAppliances.push(filterOperationResult.rootApply);
    }
    return {
        clause: (qb)=>{
            for (const each of clauses){
                each(qb);
            }
        },
        rootApply: (qb)=>{
            for (const each of rootAppliances){
                each == null ? void 0 : each(qb);
            }
        }
    };
}
const unsupportedFilter = async (_args, rootArgs, _options)=>{
    var _rootArgs_filter;
    return _ncError.NcError._.unsupportedFilterOperation(rootArgs == null ? void 0 : (_rootArgs_filter = rootArgs.filter) == null ? void 0 : _rootArgs_filter.comparison_op);
};
